import escape from "lodash/escape"
import { EventsProps } from "./Events"
import { ContentSummary, ContentSummaryVariant } from "common/components/ContentSummary"
import { imageSizes } from "common/lib/imageSizes"

/**
 * Component for displaying events
 */
export const EventsView = ({ events = [] }: EventsProps) => {
  "use memo"

  return (
    <section className="mb-4">
      <div className="grid grid-cols-3 gap-4 sm:gap-6 md:grid-cols-12">
        {events.map(({ name, trackingUrl, byline, imageSrc }, index) => (
          <div
            key={index}
            className="col-span-full flex justify-between gap-3 border-t border-gray-200 pt-4 md:col-span-6"
          >
            <ContentSummary
              // `ContentSummary` renders `title` as HTML, but an event name
              // is plain text that anyone can submit through the events form.
              title={escape(name)}
              url={trackingUrl}
              byline={byline}
              image={{ src: imageSrc ? imageSrc : undefined }}
              variant={ContentSummaryVariant.BaseWide}
              imageSizes={imageSizes({ lg: 0.125, sm: 0.25 })}
              imageFit="contain"
            />
          </div>
        ))}
      </div>
    </section>
  )
}
